//Protocols derived from https://git.hubteam.com/HubSpot/sanitize-text/blob/master/static/js/transformers/removeInvalidAnchorProtocols.ts
// eslint-disable-next-line no-script-url
const BLOCKLISTED_PROTOCOLS = ['javascript:', 'vbscript:', 'data:'];
export const isSafeLink = url => {
  try {
    const _url = new URL(url);
    return !BLOCKLISTED_PROTOCOLS.includes(_url.protocol);
  } catch (_unused) {
    return false;
  }
};